import { Factory, Globe, Boxes, Store } from "lucide-react";
import { motion } from "framer-motion";
import image from '../assets/logo/logomobile.png'

const solutions = [
  {
    title: "Direct-to-Consumer (D2C) Brands",
    icon: <Store className="text-yellow-300 w-6 h-6" />,
    description:
      "We empower emerging and established D2C brands with fast, trackable shipping and warehouse-to-doorstep delivery — ensuring every customer experience is premium and seamless.",
  },
  {
    title: "Enterprise & B2B Logistics",
    icon: <Factory className="text-yellow-300 w-6 h-6" />,
    description:
      "From manufacturers to distributors, we offer customized bulk movement solutions, FTL/PTL shipments, and advanced freight management across India with SLA-backed reliability.",
  },
  {
    title: "Global Trade & Freight Forwarding",
    icon: <Globe className="text-yellow-300 w-6 h-6" />,
    description:
      "Our cross-border capabilities enable import/export businesses to move goods globally through integrated ocean, air, and land freight solutions — with real-time visibility and customs handling.",
  },
  {
    title: "3PL & Omni-channel Retailers",
    icon: <Boxes className="text-yellow-300 w-6 h-6" />,
    description:
      "We act as your trusted 3PL partner — providing warehousing, pick-pack-ship, multi-location fulfillment, and integration with your ERP or eCommerce stack to streamline inventory & last-mile delivery.",
  },
];

export default function ShippingSolutionsSection() {
  return (
    <section className="bg-[#211f57] text-white py-10 px-4 relative overflow-hidden">
      {/* Heading */}
      <div className="text-center max-w-4xl mx-auto mb-16">
        <h2 className="text-3xl md:text-4xl font-semibold text-white text-center">
          <span className="text-white">One platform —</span>{" "}
          <span className="text-red-600"> Every business</span>
          <br />
          <span className="text-white md:text-xl">
            Whether you're D2C, B2B, or 3PL, our platform adapts and scales with your journey.
          </span>
        </h2>
      </div>

      {/* Grid Layout */}
      <div className="relative max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 items-center">
        <div className="flex flex-col space-y-12">
          {solutions.slice(0, 2).map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.2 }}
              viewport={{ once: true }}
              className="flex items-start space-x-4"
            >
              <div className="bg-white bg-opacity-10 p-4 rounded-full">{item.icon}</div>
              <div>
                <h4 className="text-lg font-semibold text-white">{item.title}</h4>
                <p className="text-gray-400 text-sm mt-1">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Center Visual */}
        <div className="hidden md:flex items-center justify-center relative">
          {/* Outer spinning ring 1 */}
          <div className="absolute w-80 h-80 rounded-full border-t-4 border-[#fff44f] animate-spin-slow" />

          {/* Outer spinning ring 2 (opposite direction, offset size) */}
          <div className="absolute w-72 h-72 rounded-full border-b-4 border-[#fff44f] animate-spin-slow-reverse" />

          {/* Main dashed circle */}
          <div className="w-64 h-64 rounded-full border-2 border-dashed border-[#fff44f] flex items-center justify-center relative z-10">
            <img src={image} alt="S Infinite Express Logo" />
          </div>
        </div>

        <div className="flex flex-col space-y-12">
          {solutions.slice(2).map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.2 }}
              viewport={{ once: true }}
              className="flex items-start space-x-4"
            >
              <div className="bg-white bg-opacity-10 p-4 rounded-full">{item.icon}</div>
              <div>
                <h4 className="text-lg font-semibold text-white">{item.title}</h4>
                <p className="text-gray-400 text-sm mt-1">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}